// helper.tsx

import moment from "moment";
import {
  PAYMENT_STATUS,
  PAYMENT_STATUS_VALUE,
  PaymentMethod,
  WALLET_TRANSACTION_STATUS,
} from "../components/Utils/constants";

export const formatCurrency = (amount = 0, decimalPlaces = 2) => {
  // Create Intl.NumberFormat object with Nigerian currency format
  const formatter = new Intl.NumberFormat("en-NG", {
    style: "currency",
    currency: "NGN",
    minimumFractionDigits: decimalPlaces,
  });

  // Format the currency
  return formatter.format(amount);
};

export const roundToTwoDecimalPlaces = (value: number | undefined): number | undefined => {
  if (value === undefined) return undefined;
  return Math.round(value * 100) / 100;
};

export const addSpacesToCamelCase = (str: string) => {
  return str.replace(/([a-z])([A-Z])/g, "$1 $2").toLowerCase();
};

export const numberWithCommasOnly = (x: any, precision: any) => {
  if (!x && x !== 0) return "";

  if (precision) {
    x = Number(x).toFixed(precision);
  }

  var parts = x.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
};

export const getStatusStyleName = (status: number, label?: string) => {
  switch (status) {
    case PAYMENT_STATUS_VALUE.UNPAID:
      return {
        styles: "w-[7px] h-[7px] bg-[#1c1f1d] rounded-[50%]",
        label: label ? label : PAYMENT_STATUS.UNPAID,
        backgroundColor: "#f5f5f5",
        color: "#1c1f1d",
      };
    case PAYMENT_STATUS_VALUE.SUCCESS:
      return {
        styles: "w-[7px] h-[7px] bg-[#1c5d3d] rounded-[50%]",
        label: label ? label : PAYMENT_STATUS.SUCCESS,
        backgroundColor: "#defcee",
        color: "#1c5d3d",
      };
    case PAYMENT_STATUS_VALUE.PENDING:
      return {
        styles: "w-[7px] h-[7px] bg-[#dc8204] rounded-[50%]",
        label: label ? label : PAYMENT_STATUS.PENDING,
        backgroundColor: "#fff8ee",
        color: "#dc8204",
      };
    case PAYMENT_STATUS_VALUE.FAILED:
      return {
        styles: "w-[7px] h-[7px] bg-[#e12c2c] rounded-[50%]",
        label: label ? label : PAYMENT_STATUS.FAILED,
        backgroundColor: "#ffe8e8",
        color: "#e12c2c",
      };
    case PAYMENT_STATUS_VALUE.PAID:
      return {
        styles: "w-[7px] h-[7px] bg-[#0a66c2] rounded-[50%]",
        label: label ? label : PAYMENT_STATUS.PAID,
        backgroundColor: "#e6f0fa",
        color: "#0a66c2",
      };
    case PAYMENT_STATUS_VALUE.AWAITING_VENDING:
      return {
        styles: "w-[7px] h-[7px] bg-[#6a1b9a] rounded-[50%]",
        label: label ? label : PAYMENT_STATUS.AWAITING_VENDING,
        backgroundColor: "#f3e5f5",
        color: "#6a1b9a",
      };
    default:
      return {
        styles: "w-[7px] h-[7px] bg-[#FFA500] rounded-[50%]",
        label: label ? label : PAYMENT_STATUS.PENDING,
      };
  }
};
export const getWalletStatusStyleName = (status: number, label?: string) => {
  switch (status) {
    case WALLET_TRANSACTION_STATUS.UNPAID:
      return {
        styles: "w-[7px] h-[7px] bg-[#1c1f1d] rounded-[50%]",
        label: label ? label : PAYMENT_STATUS.UNPAID,
        backgroundColor: "#f5f5f5",
        color: "#1c1f1d",
      };
    case WALLET_TRANSACTION_STATUS.PAID:
      return {
        styles: "w-[7px] h-[7px] bg-[#1c5d3d] rounded-[50%]",
        label: label ? label : PAYMENT_STATUS.SUCCESS,
        backgroundColor: "#defcee",
        color: "#1c5d3d",
      };
    case WALLET_TRANSACTION_STATUS.PENDING:
      return {
        styles: "w-[7px] h-[7px] bg-[#dc8204] rounded-[50%]",
        label: label ? label : PAYMENT_STATUS.PENDING,
        backgroundColor: "#fff8ee",
        color: "#dc8204",
      };

    default:
      return {
        styles: "w-[7px] h-[7px] bg-[#FFA500] rounded-[50%]",
        label: label ? label :  'Unknown',
      };
  }
};

export const getPaymentMethodDisplayName = (paymentMethod: number) => {
  switch (paymentMethod) {
    case PaymentMethod.Remita:
      return "Remita";
    case PaymentMethod.Wallet:
      return "Wallet";

    default:
      return "---------";
  }
};

export const getPaymentStatusDisplayName = (paymentStatus: number) => {
  switch (paymentStatus) {
    case PAYMENT_STATUS_VALUE.PENDING:
      return "Pending";
    case PAYMENT_STATUS_VALUE.SUCCESS:
      return "Successful";
    case PAYMENT_STATUS_VALUE.FAILED:
      return "Failed";
    case PAYMENT_STATUS_VALUE.UNPAID:
      return "Unpaid";
    case PAYMENT_STATUS_VALUE.PAID:
      return "Paid";
    case PAYMENT_STATUS_VALUE.AWAITING_VENDING:
      return "Awaiting Vending";

    default:
      return "---------";
  }
};

export function formatDate(dateString: string) {
  const date = moment(dateString);
  const now = moment();

  if (date.isSame(now, "day")) {
    return `Today ${date.format("h:mm A")}`;
  } else if (date.isSame(now.clone().subtract(1, "day"), "day")) {
    return `Yesterday ${date.format("h:mm A")}`;
  } else {
    return date.format("MMM D, h:mm A");
  }
}

export const formatDateTime = (value?: string) => {
  if (!value) return "";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? value : date.toLocaleString();
};


  export const formatKctCode = (code: string) => {
    if (!code) return "";

    return code
      .replace(/\s/g, "")
      .replace(/(.{4})/g, "$1 ")
      .trim();
  };